import {useSelector} from "react-redux";

export default function () {
    const message = useSelector(state => state.messages.nextMessage);
    const loading = useSelector(state => state.messages.loadingNextMessage);
    return { message, loading };
}